import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Observable } from "rxjs/Observable"
import { DialogCustomListaMensagensComponent } from '../components/dialog-custom-lista-mensagens/dialog-custom-lista-mensagens.component';
import { DialogCustomComponent } from '../components/dialog-custom/dialog-custom.component';
import { EnumTipoMensagem, EnumTipoResultado } from '../enum/enum-infra';

@Injectable()
export class MessageService {

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  btClose = 'X';
  width = '400px';
  duration = 5000;

  constructor(private snackBar: MatSnackBar, public dialog: MatDialog) { }

  /*show(msg: string, enumTipoMensagem: EnumTipoMensagem): void {
    var msgLista = new Array<string>();
    msgLista.push(msg);
    const dialogRef = this.dialog.open(DialogCustomComponent, {
      width: this.width,
      data: {
        msg: msgLista,
        enumTipoMensagem: enumTipoMensagem,
        isConfirm: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }*/

  show(msg: string, enumTipoMensagem: EnumTipoMensagem, confirm: boolean = false): void {
    this.scrollToTop()
    const dialogRef = this.dialog.open(DialogCustomComponent, {
      width: this.width,
      data: {
        msg: msg,
        enumTipoMensagem: enumTipoMensagem,
        isConfirm: confirm
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('Dialog Closed');
    });
  }

  showWithObservable(msg: string, enumTipoMensagem: EnumTipoMensagem): Observable<Boolean> {
    var msgLista = new Array<string>();
    msgLista.push(msg);
    const observable = new Observable<Boolean>((observer) => {
      const dialogRef = this.dialog.open(DialogCustomComponent, {
        width: this.width,
        data: {
          msg: msgLista,
          enumTipoMensagem: enumTipoMensagem,
          isConfirm: false,
          observer: observer
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    });
    return observable;
  }

  showWithObservableListaMensagens(msg: Array<string>, enumTipoMensagem: EnumTipoMensagem, width: string = "400px"): Observable<Boolean> {
    this.width = width;
    const observable = new Observable<Boolean>((observer) => {
      const dialogRef = this.dialog.open(DialogCustomComponent, {
        width: this.width,
        data: {
          msg: msg,
          enumTipoMensagem: enumTipoMensagem,
          isConfirm: false,
          observer: observer
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    });
    return observable;
  }

  showConfirmCallBack(msg: string, enumTipoMensagem: EnumTipoMensagem = EnumTipoMensagem.Alerta, callBackConfirm: any, callBackCancel?: any): void {
    var msgLista = new Array<string>();
    msgLista.push(msg);
    const dialogRef = this.dialog.open(DialogCustomComponent, {
      width: this.width,
      data: {
        msg: msgLista,
        enumTipoMensagem: enumTipoMensagem,
        isConfirm: true,
        callBackConfirm: callBackConfirm,
        callBackCancel: callBackCancel,
        observer: null
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  scrollToTop() {
    window.scroll(0, 0)
  }

  showCallBack(msg: string, enumTipoMensagem: EnumTipoMensagem, callBackConfirm: any): void {
    this.scrollToTop()
    const dialogRef = this.dialog.open(DialogCustomComponent, {
      width: this.width,
      data: {
        msg: msg,
        enumTipoMensagem: enumTipoMensagem,
        isConfirm: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      callBackConfirm()
    });
  }

  showConfirm(msg: string, enumTipoMensagem: EnumTipoMensagem = EnumTipoMensagem.Alerta): Observable<Boolean> {
    var msgLista = new Array<string>();
    msgLista.push(msg);
    const observable = new Observable<Boolean>((observer) => {

      const dialogRef = this.dialog.open(DialogCustomComponent, {
        width: this.width,
        data: {
          msg: msgLista,
          enumTipoMensagem: enumTipoMensagem,
          isConfirm: true,
          callBackConfirm: null,
          callBackCancel: null,
          observer: observer
        }
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    })
    return observable;
  }

  showConfirmListaMensagens(msg: Array<string>, enumTipoMensagem: EnumTipoMensagem = EnumTipoMensagem.Alerta, width: string = "400px"): Observable<Boolean> {
    this.width = width;
    const observable = new Observable<Boolean>((observer) => {

      const dialogRef = this.dialog.open(DialogCustomListaMensagensComponent, {
        width: this.width,
        panelClass: "modal-confirmar-service",
        data: {
          msg: msg,
          enumTipoMensagem: enumTipoMensagem,
          isConfirm: true,
          callBackConfirm: null,
          callBackCancel: null,
          observer: observer
        }
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    })
    return observable;
  }

  showNotify(msg: string, enumTipoMensagem: EnumTipoMensagem): void {

    switch (enumTipoMensagem) {

      case EnumTipoMensagem.Sucesso:
        this.notify(msg, ['snack-success']);
        break;

      case EnumTipoMensagem.Erro:
        this.notify(msg, ['snack-error']);
        break;

      case EnumTipoMensagem.Alerta:
        this.notify(msg, ['snack-alert']);
        break;

      case EnumTipoMensagem.Info:
      case EnumTipoMensagem.Indefinido:
      default:
        this.notify(msg, ['snack-info']);
        break;
    }
  }

  private notify(msg: string, panelClass: string[]): void {
    this.snackBar.open(msg, this.btClose, {
      duration: this.duration,
      panelClass: panelClass,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }

  verifyBackendMessageError(response: any): void {

    if (!response.hasOwnProperty('returnCode') || !response.hasOwnProperty('message')) {
      return;
    }

    if (response.message.length == 0)
      return;

    let msg = '';

    switch (response.returnCode) {
      case EnumTipoResultado.Indefinido:
      case EnumTipoResultado.Sucesso:
        //Do Nothing
        break;
      case EnumTipoResultado.Info:
      case EnumTipoResultado.Alerta:
      case EnumTipoResultado.Erro:
        msg = response.message;
        break;
    }

    this.showNotify(msg, EnumTipoMensagem.Erro);
  }
}

